import { ICompany } from '../common/models/Company'
import { IRequest, RequestType } from '../common/models/Request'
import { isRequestTypeModuleEnabled } from '../common/helpers/moduleAccess.helper'

// Drops request types whose module is disabled for the company, so badges/lists
// never link into a now-hidden page. Absent module flags = the module's default.
export const filterRequestsByModuleAccess = (
  requests: IRequest[],
  company: ICompany | undefined
): IRequest[] =>
  requests.filter((request) =>
    isRequestTypeModuleEnabled(company?.settings, request.actionType)
  )

// A survey to fill in reaches a member on every plan and with advanced engagement off,
// so it alone gives the personal page something to show
export const hasOpenSurveyRequest = (requests: IRequest[]) =>
  requests.some(
    ({ actionType, completed }) =>
      actionType === RequestType.FILL_SURVEY && !completed
  )

export const getOwnRequests = (requests: IRequest[]) => {
  return requests.filter(
    (request) =>
      request.actionType === RequestType.SET_GOALS ||
      request.actionType === RequestType.SET_GOALS_EARLY_EVALUATION ||
      request.actionType === RequestType.SET_GOALS_SKIPPED_EVALUATION ||
      request.actionType === RequestType.START_ONBOARDING ||
      request.actionType === RequestType.REVIEW_GOALS ||
      request.actionType === RequestType.LEAVE_FEEDBACK ||
      request.actionType === RequestType.EVALUATE ||
      request.actionType === RequestType.SPECIFY_CLOSE_MEMBERS ||
      request.actionType === RequestType.FILL_SURVEY
  )
}

export const getCompanyRequests = (requests: IRequest[]) => {
  return requests.filter(
    (request) =>
      request.actionType === RequestType.PLAN_EVALUATIONS ||
      request.actionType === RequestType.CLOSE_EVALUATION ||
      request.actionType === RequestType.DELETE_ARCHIVED_MEMBERS ||
      request.actionType === RequestType.COMPLETE_PROFILE ||
      request.actionType === RequestType.COMPLETE_COMPANY_PROFILE
  )
}
